import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetGeneralLedgerQuery } from "../../../services/Reports";
import {
  getGeneralLedgerRequest,
  getGeneralLedgerFailure,
  getGeneralLedgerSuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);
  const accountState = useAppSelector((state) => state.accountCharts);
  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allGeneralLedger,
    isLoading: generalLedgerLoading,
    isError: generalLedgerError,
  } = useGetGeneralLedgerQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.generalLedgerPageNo,
    pageSize: state.generalLedgerPageSize,
    fromDate: new Date(state.generalLedgerFromDate).toLocaleDateString(),
    toDate: new Date(state.generalLedgerToDate).toLocaleDateString(),
    accountId: accountState.accountId,
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (generalLedgerLoading) {
      dispatch(getGeneralLedgerRequest());
    }
    if (generalLedgerError) {
      dispatch(getGeneralLedgerFailure(generalLedgerError));
    }
    if (allGeneralLedger) {
      dispatch(
        getGeneralLedgerSuccess({
          data: allGeneralLedger.data.generalLedger[0].data || [],
          totalPages:
            allGeneralLedger.data.generalLedger[0].metadata[0]?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allGeneralLedger,
    profileData,
    state.generalLedgerFromDate,
    state.generalLedgerToDate,
    state.generalLedgerPageNo,
    state.generalLedgerPageSize,
  ]);
  return <></>;
};
export default Content;
